import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router";
import classNames from 'classnames';
import style from './HotRank.module.css';
import { getHotRank } from "./service";
import newsDetailPushTarget from "../../utils/NewsDetailPushTarget";


const HotRank = (props) => {
    const { history } = props;
    const [hotNews, setHotNews] = useState([]);

    useEffect(() => {
        (async () => {
            const { data } = await getHotRank();
            setHotNews(data);
        })();
    }, []);

    return (
        <div className={style.wrapper}>
            <div className={style.title}>热度排行</div>
            <div className={style.hotNewsWrapper}>
                {
                    hotNews.map((item, index) => {
                        const { title, tab, id } = item;
                        return (
                            <div
                                key={index}
                                className={style.hotNews}
                                onClick={() => {
                                    window.scrollTo(0,300);
                                    history.push({ pathname: `/${newsDetailPushTarget(tab)}/${id}`});
                                }}
                            >
                                <div className={classNames([style.hotNewsLabel, index < 3 && style[`hotNewsLabel${index + 1}`]])}>{index < 9 && '0'}{index + 1}</div>
                                <span className={style.hotNewsTitle}> {title}</span>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
}

export default connect()(withRouter(HotRank));
